import { createContext, useContext } from "react";

export const AnatomyFilterContext = createContext();
export const AnatomyDataContext = createContext();
export const AnatomyUIContext = createContext();

export const useAnatomyFilter = () => useContext(AnatomyFilterContext);
export const useAnatomyData = () => useContext(AnatomyDataContext);
export const useAnatomyUI = () => useContext(AnatomyUIContext);
